export function initVipSwitcher() {
  const buttons = document.querySelectorAll('.vip-switcher__btn');
  const tabs = document.querySelectorAll('.vip-tab');
  const vipNav = document.querySelector('.vip-tabs');

  if (!buttons.length || !tabs.length) return;

  buttons.forEach((btn) => {
    btn.addEventListener('click', () => {
      const tabId = btn.dataset.tab;

      buttons.forEach((b) => b.classList.remove('is-active'));
      btn.classList.add('is-active');

      tabs.forEach((tab) => {
        tab.hidden = tab.dataset.tab !== tabId;

        const activeTab = document.querySelector(`.vip-tab[data-tab="${tabId}"]`);
        if (activeTab) {
          requestAnimationFrame(() => {
            setTimeout(() => {
              let offset = getStickyOffset();

              if (window.innerWidth > 768) {
                offset += 90;
              }

              const top = activeTab.getBoundingClientRect().top + window.scrollY - offset;
              window.scrollTo({ top, behavior: 'smooth' });
            }, 80);
          });
        }
      });
    });
  });
}

function getStickyOffset() {
  const sticky = document.querySelector('.vip__nav');
  const isMobile = window.innerWidth <= 768;
  const isFixed = sticky?.classList.contains('is-fixed');
  if (isFixed) {
    return isMobile ? sticky.offsetHeight + 40 : sticky.offsetHeight;
  }
  const fallbackHeight = 120;

  return isMobile ? fallbackHeight + 40 : fallbackHeight;
}

export function initVipNavLinks() {
  const links = document.querySelectorAll('.vip__nav--link');

  links.forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();

      links.forEach(l => l.classList.remove('is-active'));
      const href = link.getAttribute('href');
      if (href === '#more') return;
      links.forEach(l => l.classList.remove('is-active'));
      link.classList.add('is-active');

      const target = document.querySelector(href);
      const targetTab = link.dataset.tab;
      const activeTab = document.querySelector('.vip-switcher__btn.is-active')?.dataset.tab;

      if (!target) return;

      const scrollToTarget = () => {
        requestAnimationFrame(() => {
          setTimeout(() => {
            const offset = getStickyOffset() + Number(target.dataset.offset || 0);
            const top = target.getBoundingClientRect().top + window.scrollY - offset;
            window.scrollTo({ top, behavior: 'smooth' });
          }, 150);
        });
      };


      if (activeTab !== targetTab) {
        const btnToClick = document.querySelector(`.vip-switcher__btn[data-tab="${targetTab}"]`);
        btnToClick?.click();

        requestAnimationFrame(() => {
          setTimeout(scrollToTarget, 80);
        });
      } else {
        scrollToTarget();
      }
    });
  });
}

export function observeVipSections() {
  const links = document.querySelectorAll('.vip__nav--link');
  const sections = Array.from(links).map(link => {
    const href = link.getAttribute('href');
    if (href === '#more') return null;
    return document.querySelector(href);
  }).filter(Boolean);


  let currentId = null;

  const observer = new IntersectionObserver((entries) => {
    const visibleEntries = entries
      .filter(entry => entry.isIntersecting)
      .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);

    if (visibleEntries.length > 0) {
      const id = visibleEntries[0].target.getAttribute('id');
      if (id !== currentId) {
        currentId = id;
        updateActiveLink(id);
      }
    }
  }, {
    threshold: 0.9,
  });

  sections.forEach(section => observer.observe(section));

  function updateActiveLink(activeId) {
    links.forEach(link => {
      const linkId = link.getAttribute('href')?.replace('#', '');
      link.classList.toggle('is-active', linkId === activeId);
    });
  }

  window.addEventListener('scroll', () => {
    const offset = getStickyOffset();

    const visibleSection = sections.find(section => {
      const rect = section.getBoundingClientRect();
      return rect.bottom > offset && rect.top < window.innerHeight;
    });


    if (!visibleSection && currentId !== null) {
      currentId = null;
      links.forEach(link => link.classList.remove('is-active'));
    }
  }, { passive: true });
}



